import {
  fetchGetMobileAnnouncementDraft,
  IMappers,
} from '../../repositories/announcements/v1/get-mobile-announcement-draft';
import { IGetOfferDraftParams, TGetOfferDraftResult } from './types';
import { mapResponse200, mapResponse400 } from './utils';

export async function getOfferDraft(params: IGetOfferDraftParams): Promise<TGetOfferDraftResult> {
  const { httpApi, draftGuid } = params;

  const parameters = {
    draftGuid,
  };

  const mappers: IMappers<TGetOfferDraftResult, null> = {
    200: mapResponse200,
    400: mapResponse400,
  };

  try {
    const result = await fetchGetMobileAnnouncementDraft({ httpApi, parameters, mappers });

    return result as TGetOfferDraftResult;
  } catch (error) {
    return null;
  }
}
